export default {
  brand: {
    fileShare: 'File Share'
  },
  common: {
    loading: 'Loading...',
    confirm: 'Confirm',
    cancel: 'Cancel',
    download: 'Download',
    downloadAll: 'Download All',
    downloadSelected: 'Download Selected',
    selectAll: 'Select All',
    deselectAll: 'Deselect',
    rootDirectory: 'Root Directory',
    createTime: 'Created',
    expireTime: 'Expires',
    totalSize: 'Total Size',
    noFiles: 'No files'
  },
  share: {
    expired: 'The shared files have expired',
    invalidLink: 'Invalid share link',
    needVerifyCode: 'Please enter the extraction code',
    verifyCodeLabel: 'Code',
    verifyCodePlaceholder: 'Enter extraction code',
    extractFiles: 'Extract Files',
    extractionCodeError: 'Incorrect extraction code',
    uuidRequestFailed: 'Download request failed',
    selectFilesFirst: 'Please select files first',
    unknownError: 'Unknown error'
  },
  error: {
    networkError: 'Network error',
    connectionFailed: 'Unable to connect to the sharing device. The device may be powered off, in sleep mode, or the service region may have changed. Please contact the sharer.',
    outdatedLink: 'Unable to connect to the sharing device. An outdated share link may have been used. Please ask the sharer to upgrade the system to v2.0.10 or above, the APP to v2.1.5 or above, and re-copy the share link.',
    registryError: 'Error retrieving public network penetration settings. Unable to connect to Registry service.',
    missingRegion: 'The share link is missing service region information. Please ask the sharer to upgrade the system to v2.0.10 or above, the APP to v2.1.5 or above, and re-copy the share link.'
  }
}
